export const AUTH = {
  SET_USER: 'SET_USER',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE',
  SET_FILE_ID: 'SET_FILE_ID'
};

export const GLOBAL = {
  SET_LOADING: 'SET_LOADING',
  SET_COMPANY_DATA: 'SET_COMPANY_DATA',
  SET_FEATURES_DATA: 'SET_FEATURES_DATA',
  SET_CLIENT_CONFIG: 'SET_CLIENT_CONFIG',
  SET_BLOCK_DIALOG: 'SET_BLOCK_DIALOG',
  SET_PAIR_DIALOG_HELPER: 'SET_PAIR_DIALOG_HELPER',
  INITIAL_SETTINGS_LOADED: 'INITIAL_SETTINGS_LOADED',
  SET_WINDOW_WIDTH: 'SET_WINDOW_WIDTH',
  SET_WINDOW_HEIGHT: 'SET_WINDOW_HEIGHT',
  SET_INITIAL_SETTINGS: 'SET_INITIAL_SETTINGS'
};

export const CLIENT = {
  CLIENT_SET: 'CLIENT_SET',
  SET_CLIENT_CONFIG: 'SET_CLIENT_CONFIG',
  RESTORE_CLIENT_CONFIG: 'RESTORE_CLIENT_CONFIG',
  SET_CLIENT_ID: 'SET_CLIENT_ID',
  SET_CLIENT_DOMAINS: 'SET_CLIENT_DOMAINS',
  SET_CLIENT_ADMIN: 'SET_CLIENT_ADMIN'
};

export const DESK = {
  DESK_SET: 'DESK_SET',
  DESKS_COUNT_SET: 'DESKS_COUNT_SET',
  PATTERN_SET: 'PATTERN_SET',
  AVAILABLE_DESK_SET: 'AVAILABLE_DESK_SET',
  DESK_WITH_LOCATION_SET: 'DESK_WITH_LOCATION_SET',
  UPDATE_DESK: 'UPDATE_DESK',
  DESKS_POSITIONS: 'DESKS_POSITIONS',
  DESKS_BY_SITE: 'DESKS_BY_SITE'
};


export const CHARTERED = {
  CHARTERED_SET: 'CHARTERED_SET',
  AVAILABLE_CHARTERED_BUSES_SET: 'AVAILABLE_CHARTERED_BUSES_SET',
  SET_SITE: 'SET_SITE',
  SET_CHARTEREDS_GROUPED_BY_SITE: 'SET_CHARTEREDS_GROUPED_BY_SITE',
  SET_SITE_ID: 'SET_SITE_ID'
};

export const CHARTERED_BOOKING = {
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  SET_DATE: 'SET_DATE',
  SET_CHARTEREDS: 'SET_CHARTEREDS',
  SET_CHARTERED_ID: 'SET_CHARTERED_ID',
  SET_SITE_ID: 'SET_SITE_ID',
  SET_CUSTOM_TRIP: 'SET_CUSTOM_TRIP',
  SET_CHARTERED_BUS_BY_TRIP_TYPE: 'SET_CHARTERED_BUS_BY_TRIP_TYPE',
  SET_SELECTED_CHARTERED: 'SET_SELECTED_CHARTERED',
  DELETE_SELECTED_CHARTERED: 'DELETE_SELECTED_CHARTERED',
  INIT_SELECTED_CHARTERED: 'INIT_SELECTED_CHARTERED',
  CLEAR_SELECTED_CHARTERED: 'CLEAR_SELECTED_CHARTERED',
  SET_LOADED_FIRST_TIME: 'SET_LOADED_FIRST_TIME',
  SET_CHARTERED_BUS_BOOKINGS: 'SET_CHARTERED_BUS_BOOKINGS',
  SET_QUERY_FILTER: 'SET_QUERY_FILTER',
  SET_CHARTERED_BUS_QUERY_FILTER: 'SET_CHARTERED_BUS_QUERY_FILTER',
  SET_FILTER_DATE: 'SET_FILTER_DATE'
};

export const PARKING_BOOKING = {
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  SET_DATE: 'SET_DATE',
  CURRENT_SET_DATE: 'CURRENT_SET_DATE',
  SET_PARKINGS: 'SET_PARKINGS',
  SET_PARKING_ID: 'SET_PARKING_ID',
  SET_SITE_ID: 'SET_SITE_ID',
  SET_VEHICLE_ID: 'SET_VEHICLE_ID',
  SET_LOADED_FIRST_TIME: 'SET_LOADED_FIRST_TIME',
  SET_HAS_ERROR_VALIDATION: 'SET_HAS_ERROR_VALIDATION',
  SET_MIN_CALENDAR_DATE: 'SET_MIN_CALENDAR_DATE',
  SET_MAX_CALENDAR_DATE: 'SET_MAX_CALENDAR_DATE',
  SET_START_TIME: 'SET_START_TIME',
  SET_END_TIME: 'SET_END_TIME',
  SET_FULL_START_DATE: 'SET_FULL_START_DATE',
  SET_FULL_END_DATE: 'SET_FULL_END_DATE',
  SET_PARKING_BOOKING: 'SET_PARKING_BOOKING',
  SET_QUERY_FILTER: 'SET_QUERY_FILTER',
  SET_PARKING_QUERY_FILTER: 'SET_PARKING_QUERY_FILTER',
  SET_VEHICLES: 'SET_VEHICLES'
};

export const TVS = {
  TVS_SET: 'TVS_SET',
  SET_ID: 'SET_ID'
};

export const TABLETS = {
  TABLETS_SET: 'TABLETS_SET',
  SET_ID: 'SET_ID'
};

export const CAMERAS = {
  CAMERAS_SET: 'CAMERAS_SET',
  SET_ID: 'SET_ID'
};

export const SERVICE_DESK = {
  SET_REQUESTS: 'SET_REQUESTS',
  SET_DATE: 'SET_DATE',
  SET_SERVICE_DESK_TYPE: 'SET_SERVICE_DESK_TYPE',
  SET_TYPES: 'SET_TYPES'
};

export const ADMINISTRATOR = {
  SET_ADMINISTRATORS: 'SET_ADMINISTRATORS'
};
export const EMPLOYEE_GROUPS = {
  SET_GROUPS: 'SET_GROUPS',
  SET_GROUP_ID: 'SET_GROUP_ID',
  SET_GROUP_NAME: 'SET_GROUP_NAME',
  SET_GROUP_IMPORTCODE: 'SET_GROUP_IMPORTCODE',
  SET_GROUP_TEAM_MANAGERS: 'SET_GROUP_TEAM_MANAGERS',
  SET_GROUP_DESKGROUPS: 'SET_GROUP_DESKGROUPS',
  SET_GROUP_CHARTEREDBUSES: 'SET_GROUP_CHARTEREDBUSES',
  SET_GROUP_PARKINGS: 'SET_GROUP_PARKINGS',
  SET_GROUP_LOCKERS: 'SET_GROUP_LOCKERS',
  SET_GROUP_ROOMS: 'SET_GROUP_ROOMS',
  SET_GROUP_EMPLOYEES: 'SET_GROUP_EMPLOYEES',
  SELECT_EMPLOYEES: 'SELECT_EMPLOYEES',
  SET_AVAILABLE_GROUPS: 'SET_AVAILABLE_GROUPS',
  SET_AVAILABLE_CHARTERED_BUSES: 'SET_AVAILABLE_CHARTERED_BUSES',
  SET_AVAILABLE_PARKINGS: 'SET_AVAILABLE_PARKINGS',
  SET_AVAILABLE_LOCKERS: 'SET_AVAILABLE_LOCKERS',
  SET_AVAILABLE_ROOMS: 'SET_AVAILABLE_ROOMS',
  SET_FILE_STATUS: 'SET_FILE_STATUS',
  SET_FILE_ID: 'SET_FILE_ID',
  SELECT_TEAM_MANAGER: 'SELECT_TEAM_MANAGER',
  REMOVE_TEAM_MANAGER: 'REMOVE_TEAM_MANAGER',
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE',
  SET_CANCEL_FUTURE_BOOKINGS: 'SET_CANCEL_FUTURE_BOOKINGS',
  SELECT_ALL_GROUP: 'SELECT_ALL_GROUP',
  SELECT_GROUP: 'SELECT_GROUP',
  REMOVE_EMPLOYEES: 'REMOVE_EMPLOYEES',
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
  ADD_GROUP_EMPLOYEES: 'ADD_GROUP_EMPLOYEES',
  SET_GROUPS_INFO: 'SET_GROUPS_INFO',
  REMOVE_FROM_EMPLOYEE_GROUP: 'REMOVE_FROM_EMPLOYEE_GROUP',
  SET_REMOVE_LIST: 'SET_REMOVE_LIST',
  SET_EMPLOYEES: 'SET_EMPLOYEES',
  SET_LOADING_EMPLOYEES: 'SET_LOADING_EMPLOYEES',
  SET_EMPLOYEES_INFO: 'SET_EMPLOYEES_INFO',
  SET_EMPLOYEES_OUTSIDE_GROUP: 'SET_EMPLOYEES_OUTSIDE_GROUP'
};

export const DESK_GROUPS = {
  SET_GROUPS: 'SET_GROUPS',
  SET_GROUP_NAME: 'SET_GROUP_NAME',
  SET_ID: 'SET_ID',
  SET_GROUP_DESKS: 'SET_GROUP_DESKS',
  SET_AVAILABLE_DESKS: 'SET_AVAILABLE_DESKS',
  SET_DESK_ATTRIBUTES: 'SET_DESK_ATTRIBUTES',
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE'
};

export const LOCKER = {
  LOCKER_SET: 'LOCKER_SET',
  UPDATE_LOCKER: 'UPDATE_LOCKER',
  PATTERN_SET: 'PATTERN_SET',
  SET_LOCKERS: 'SET_LOCKERS',
  SET_LOCKER_NAME: 'SET_LOCKER_NAME',
  SET_ID: 'SET_ID',
  AVAILABLE_LOCKER_SET: 'AVAILABLE_LOCKER_SET',
  AVAILABLE_LOCKER_SET_FOR_MANAGER: 'AVAILABLE_LOCKER_SET_FOR_MANAGER'
};

export const NOTIFICATION_GROUPS = {
  SET_GROUPS: 'SET_GROUPS',
  SET_USERS: 'SET_USERS',
  SET_PLACES: 'SET_PLACES',
  SET_ID: 'SET_ID',
  SET_GROUP_NAME: 'SET_GROUP_NAME',
  SET_GROUP_TYPE: 'SET_GROUP_TYPE',
  SET_PLACES_SELECTED: 'SET_PLACES_SELECTED',
  SET_USERS_SELECTED: 'SET_USERS_SELECTED'
};

export const DESK_BOOKING = {
  LOG_SET: 'LOG_SET',
  CURRENT_DATE_SET: 'CURRENT_DATE_SET',
  DESK_BOOKING_SET: 'DESK_BOOKING_SET',
  SET_LOCATION_QUERY_FILTER: 'SET_LOCATION_QUERY_FILTER',
  SET_QUERY_FILTER: 'SET_QUERY_FILTER',
  SET_DATE: 'SET_DATE',
  SET_START_TIME: 'SET_START_TIME',
  SET_END_TIME: 'SET_END_TIME',
  SET_LOCATION: 'SET_LOCATION',
  SET_DESK_ATTRIBUTES: 'SET_DESK_ATTRIBUTES',
  SET_SELECTED_DESK: 'SET_SELECTED_DESK',
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  SET_FULL_START_DATE: 'SET_FULL_START_DATE',
  SET_FULL_END_DATE: 'SET_FULL_END_DATE',
  SET_LOADED_FIRST_TIME: 'SET_LOADED_FIRST_TIME',
  SET_HAS_ERROR_VALIDATION: 'SET_HAS_ERROR_VALIDATION',
  ADD_SELECTED_DESK_BOOKING: 'ADD_SELECTED_DESK_BOOKING',
  REMOVE_DESK_BOOKING: 'REMOVE_DESK_BOOKING',
  SET_SELECTED_DESK_BOOKING: 'SET_SELECTED_DESK_BOOKING',
  SET_CAN_RENDER_MAP: 'SET_CAN_RENDER_MAP',
  CHANGE_USER_DESK_BOOKING: 'CHANGE_USER_DESK_BOOKING'
};

export const USER_BOOKING = {
  SET_BOOKINGS: 'SET_BOOKINGS',
  CHANGE_STATUS: 'CHANGE_STATUS',
  SET_START_TIME: 'SET_START_TIME',
  SET_FINISH_TIME: 'SET_FINISH_TIME',
  SET_BOOKING_TYPES: 'SET_BOOKING_TYPES',
  REMOVE_BOOKING: 'REMOVE_BOOKING',
  CHANGE_ROOM_STATUS: 'CHANGE_ROOM_STATUS'
}

export const RESTAURANT_BOOKING = {
  SET_DATE: 'SET_DATE',
  SET_RESTAURANT: 'SET_RESTAURANT',
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  SET_SLOTS: 'SET_SLOTS',
  SET_SLOTID: 'SET_SLOTID',
  SET_LOADED_FIRST_TIME: 'SET_LOADED_FIRST_TIME',
  SET_QUERY_FILTER: 'SET_QUERY_FILTER',
  SET_RESTAURANT_QUERY_FILTER: 'SET_RESTAURANT_QUERY_FILTER',
  SET_FILTER_DATE: 'SET_FILTER_DATE',
  SET_RESTAURANT_BOOKINGS: 'SET_RESTAURANT_BOOKINGS'
};

export const APPLICATION_SETTINGS = {
  SET_APPLICATION_SETTINGS: 'SET_APPLICATION_SETTINGS',
  SET_API_VERSION: 'SET_API_VERSION'
}

export const SITE = {
  SET_SITES: 'SET_SITES'
}

export const RESTAURANT = {
  SET_RESTAURANTS: 'SET_RESTAURANTS',
  SET_RESTAURANTS_GROUPED_BY_SITE: 'SET_RESTAURANTS_GROUPED_BY_SITE',
  SET_SITE_ID: 'SET_SITE_ID'
}

export const LOCATION = {
  SET_LOCATIONS: 'SET_LOCATIONS',
  SET_LOCATIONS_GROUPED_BY_SITE: 'SET_LOCATIONS_GROUPED_BY_SITE',
  SET_ALL_LOCATIONS_GROUPED_BY_SITE: 'SET_ALL_LOCATIONS_GROUPED_BY_SITE',
  SET_SITE_ID: 'SET_SITE_ID',
  SET_LOCATION_DEVICES: 'SET_LOCATION_DEVICES',
  SET_LOCATION_DEVICES_BLOCK_ACCESS: 'SET_LOCATION_DEVICES_BLOCK_ACCESS',
  SET_LOCATIONS_FREEROOM: 'SET_LOCATIONS_FREEROOM',
  SET_LOCATIONS_WITH_SENSORS: 'SET_LOCATIONS_WITH_SENSORS'
}

export const PARKING = {
  SET_PARKINGS: 'SET_PARKINGS',
  AVAILABLE_PARKINGS_SET: 'AVAILABLE_PARKINGS_SET',
  SET_SITE: 'SET_SITE',
  SET_ALL_PARKINGS_GROUPED_BY_SITE: 'SET_ALL_PARKINGS_GROUPED_BY_SITE',
  SET_SITE_ID: 'SET_SITE_ID',
  SET_PARKING_DEVICES: 'SET_PARKING_DEVICES',
  SET_PARKINGS_BY_SITE: 'SET_PARKINGS_BY_SITE'
}

export const SETTINGS = {
  SET_SETTINGS: 'SET_SETTINGS',
  SET_TAB_SETTINGS: 'SET_TAB_SETTINGS',
  SET_MINIMUM_BOOKING_INTERVAL: 'SET_MINIMUM_BOOKING_INTERVAL',
  SET_MAXIMUM_BOOKING_INTERVAL: 'SET_MAXIMUM_BOOKING_INTERVAL',
  SET_COLOR_PRIMARY: 'SET_COLOR_PRIMARY',
  SET_COLOR_ACCENT: 'SET_COLOR_ACCENT',
  SELECT_USER: 'SELECT_USER',
  REMOVE_USER: 'REMOVE_USER',
  SET_UNLIMITED_BOOKINGS_FOR_USERS: 'SET_UNLIMITED_BOOKINGS_FOR_USERS',
  SET_SITE_CONFIG: 'SET_SITE_CONFIG',
  SET_SITE_SETTINGS: 'SET_SITE_SETTINGS',
  SET_SETTINGS_COLOR: 'SET_SETTINGS_COLOR'
}

export const REPORT = {
  SET_STARTDATE: 'SET_STARTDATE',
  SET_ENDDATE: 'SET_ENDDATE',
  SET_EMPLOYEEGROUPS: 'SET_EMPLOYEEGROUPS',
  SET_DESKGROUPS: 'SET_DESKGROUPS',
  SELECT_ITINERARIES: 'SELECT_ITINERARIES',
  SET_PARKINGS: 'SET_PARKINGS',
  SET_DESKS: 'SET_DESKS',
  SET_SITES: 'SET_SITES',
  SET_SITES_WITH_LOCATIONS: 'SET_SITES_WITH_LOCATIONS',
  SELECT_EMPLOYEEGROUP: 'SELECT_EMPLOYEEGROUP',
  SELECT_DESKGROUP: 'SELECT_DESKGROUP',
  SELECT_LOCATION: 'SELECT_LOCATION',
  SELECT_ITINERARY: 'SELECT_ITINERARY',
  SELECT_RESTRICTION_NAME: 'SELECT_RESTRICTION_NAME',
  SELECT_SITE: 'SELECT_SITE',
  SELECT_DESKS: 'SELECT_DESKS',
  SELECT_DESK: 'SELECT_DESK',
  SELECT_PARKING: 'SELECT_PARKING',
  SELECT_BOOKINGSTATUS: 'SELECT_BOOKINGSTATUS',
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  CLEAR_OWNER: 'CLEAR_OWNER',
  SELECT_USED_BY: 'SELECT_USED_BY',
  REMOVE_USED_BY: 'REMOVE_USED_BY',
  SELECT_SINGLE_DESK: 'SELECT_SINGLE_DESK',
  REMOVE_SINGLE_DESK: 'REMOVE_SINGLE_DESK',
  CLEAR_USED_BY: 'CLEAR_USED_BY',
  SET_DESK_REPORT: 'SET_DESK_REPORT',
  SET_CHARTERED_REPORT: 'SET_CHARTERED_REPORT',
  SET_PARKING_REPORT: 'SET_PARKING_REPORT',
  SET_ANOTHER_PERSON_AND_GUEST_REPORT: 'SET_ANOTHER_PERSON_AND_GUEST_REPORT',
  SET_LOCKER_REPORT: 'SET_LOCKER_REPORT',
  SET_RESTRICTION_REPORT: 'SET_RESTRICTION_REPORT',
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE',
  SET_REPORT_TYPE: 'SET_REPORT_TYPE',
  SET_RESTAURANT_REPORT: 'SET_RESTAURANT_REPORT',
  SET_SITES_WITH_RESTAURANTS: 'SET_SITES_WITH_RESTAURANTS',
  SET_SITES_WITH_PARKINGS: 'SET_SITES_WITH_PARKINGS',
  SELECT_RESTAURANT: 'SELECT_RESTAURANT',
  SET_UNBOOKED_ENTRANCE_REPORT: 'SET_UNBOOKED_ENTRANCE_REPORT',
  SELECT_UNBOOKED_ENTRANCE_TYPE: 'SELECT_UNBOOKED_ENTRANCE_TYPE'
}

export const DESK_ATTRIBUTES = {
  SET_DESK_ATTRIBUTE: 'SET_DESK_ATTRIBUTE',
  SET_ATTRIBUTES: 'SET_ATTRIBUTES',
  SET_ACTIVE_ATTRIBUTES: 'SET_ACTIVE_ATTRIBUTES'
};

export const MANAGER_SET = 'MANAGER_SET';
export const REGION_SET = 'REGION_SET';
export const FEATURES_SET = 'FEATURES_SET';
export const RESTRICTION_SET = 'RESTRICTION_SET';
export const UI_CONFIG_SET = 'UI_CONFIG_SET';

export const LOCKER_BOOKING = {
  CURRENT_DATE_SET: 'CURRENT_DATE_SET',
  LOCKER_BOOKING_SET: 'LOCKER_BOOKING_SET',
  SET_LOCATION_QUERY_FILTER: 'SET_LOCATION_QUERY_FILTER',
  SET_QUERY_FILTER: 'SET_QUERY_FILTER',
  SET_DATE: 'SET_DATE',
  SET_STARTTIME: 'SET_STARTTIME',
  SET_ENDTIME: 'SET_ENDTIME',
  SET_LOCATION: 'SET_LOCATION',
  SET_SELECTED_LOCKER: 'SET_SELECTED_LOCKER',
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  SET_FULL_STARTDATE: 'SET_FULL_STARTDATE',
  SET_FULL_ENDDATE: 'SET_FULL_ENDDATE',
  SET_LOADED_FIRST_TIME: 'SET_LOADED_FIRST_TIME'
}

export const USER_SETTINGS = {
  SET_COST_CENTERS: 'SET_COST_CENTERS',
  PUSH_COST_CENTER: 'PUSH_COST_CENTER',
  REMOVE_COST_CENTER: 'REMOVE_COST_CENTER',
  CLEAR_COST_CENTER: 'CLEAR_COST_CENTER',
  SET_SETTINGS: 'SET_SETTINGS',
  SET_VEHICLES: 'SET_VEHICLES'
}

export const QRCODES = {
  SET_CLIENT: 'SET_CLIENT',
  SET_SITE: 'SET_SITE',
  SET_LOCATION: 'SET_LOCATION',
  DESKS_QRCODES_FILE: 'DESKS_QRCODES_FILE',
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE'
}

export const MAP = {
  SET_START_POINTS: 'SET_START_POINTS'
}

export const CONTACT = {
  SET_CONTACT: 'SET_CONTACT'
}

export const DEVICE = {
  SET_DEVICE_STATUS: 'SET_DEVICE_STATUS',
  SET_MEASURES: 'SET_MEASURES',
  SET_DASHBOARDS: 'SET_DASHBOARDS'
}

export const RESTRICTIONS = {
  SET_AVAILABLE_GROUP_DESKGROUPS: 'SET_AVAILABLE_GROUP_DESKGROUPS',
  SET_AVAILABLE_SITES: 'SET_AVAILABLE_SITES',
  SET_AVAILABLE_DESKS: 'SET_AVAILABLE_DESKS',
  SET_AVAILABLE_PARKINGS: 'SET_AVAILABLE_PARKINGS',
  SET_RESTRICTION: 'SET_RESTRICTION'
}

export const FEATURE_FLAG = {
  SET_FEATURE_FLAGS: 'SET_FEATURE_FLAGS',
  SET_FEATURE_FLAG: 'SET_FEATURE_FLAG'
}

export const DOCUMENT = {
  SET_POLICY: 'SET_POLICY',
  SET_TERMS: 'SET_TERMS'
}

export const NOTIFICATIONALERT = {
  SET_NOTIFICATION_ALERTS: 'SET_NOTIFICATION_ALERTS',
  SET_NAME: 'SET_NAME',
  SET_LOCATIONS: 'SET_LOCATIONS',
  SET_DAYS: 'SET_DAYS',
  SET_ALL_DAY: 'SET_ALL_DAY',
  SET_ALL_LOCATIONS: 'SET_ALL_LOCATIONS',
  SET_MEASURES: 'SET_MEASURES',
  SET_RECIPIENT: 'SET_RECIPIENT',
  REMOVE_RECIPIENT: 'REMOVE_RECIPIENT',
  SET_STARTTIME: 'SET_STARTTIME',
  SET_FINISHTIME: 'SET_FINISHTIME',
  CLEAR_RECIPIENTS: 'CLEAR_RECIPIENTS',
  SET_RECIPIENTS: 'SET_RECIPIENTS',
  SET_ID: 'SET_ID',
}

export const TEAM = {
  SET_TEAMS: 'SET_TEAMS',
  SET_EMPLOYEES: 'SET_EMPLOYEES',
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
  SET_LOADING_EMPLOYEES: 'SET_LOADING_EMPLOYEES',
  ADD_EMPLOYEES: 'ADD_EMPLOYEES',
  ADD_INVITED_EMPLOYEES: 'ADD_INVITED_EMPLOYEES',
  REMOVE_INVITED_EMPLOYEES: 'REMOVE_INVITED_EMPLOYEES',
  ADD_INVITED_TEAMS: 'ADD_INVITED_TEAMS',
  REMOVE_INVITED_TEAMS: 'REMOVE_INVITED_TEAMS',
  CLEAR_GUESTS: 'CLEAR_GUESTS',
  SET_INVITES: 'SET_INVITES',
}

export const DASHBOARD_OCCUPANCY = {
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE'
}
